module.exports = __webpack_public_path__ + "img/perforaciones_3-4_1152.9af6e072.jpg";